import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickSearchComponent } from './quick-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

@NgModule({
	imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, PerfectScrollbarModule],
	declarations: [QuickSearchComponent],
	exports: [QuickSearchComponent],
})
export class QuickSearchModule {}
